import { render, staticRenderFns } from "./WhitePaperSection.vue?vue&type=template&id=7ba1be71&scoped=true"
import script from "./WhitePaperSection.vue?vue&type=script&lang=js"
export * from "./WhitePaperSection.vue?vue&type=script&lang=js"
import style0 from "./WhitePaperSection.vue?vue&type=style&index=0&id=7ba1be71&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ba1be71",
  null
  
)

export default component.exports